import { render, staticRenderFns } from "./allBooks.vue?vue&type=template&id=22340678"
import script from "./allBooks.vue?vue&type=script&lang=js"
export * from "./allBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports